import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "X-Requested-With": "XMLHttpRequest" },
});

// Access token süresi dolduğunda (401) refresh cookie ile sessizce yenile ve isteği tekrarla.
// ÖNEMLİ: Sadece GERÇEK 401 (kimlik doğrulanmadı) durumunda oturum kapatılır.
// Geçici ağ/5xx hataları oturumu düşürmez — böylece kullanıcı boşuna giriş sayfasına atılmaz.
let refreshPromise = null;
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    const status = error?.response?.status;
    const url = original?.url || "";
    const isRefreshCall = url.includes("/auth/refresh");
    const isLoginCall = url.includes("/auth/login");
    if (status === 401 && original && !original._retry && !isRefreshCall && !isLoginCall) {
      original._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
        }
        await refreshPromise;
        return api(original);
      } catch (e) {
        // Yenileme başarısız. Yalnızca gerçek 401 ise (oturum gerçekten bitti) çıkış yaptır.
        // Ağ/5xx hatasında yönlendirme yapma; istek geçici olarak başarısız olsun, oturum korunur.
        if (e?.response?.status === 401) redirectToLogin();
        return Promise.reject(error);
      }
    }
    if (status === 401 && isRefreshCall) redirectToLogin();
    return Promise.reject(error);
  }
);

function redirectToLogin() {
  const path = window.location.pathname;
  if (["/login", "/tanitim", "/forgot-password", "/gizlilik", "/kullanim-sozlesmesi"].includes(path) || path.startsWith("/reset-password") || path.startsWith("/cuzdan/")) return;
  if (path === "/") {
    window.location.assign("/tanitim");
    return;
  }
  try {
    sessionStorage.setItem("session_expired", "1");
  } catch (e) {
    // sessionStorage kullanılamıyorsa yoksay
  }
  window.location.assign("/login");
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const POLICY_TYPES = [
  "Kasko", "Trafik", "İhtiyari Mali Mesuliyet", "Sağlık", "Özel Sağlık", "Tamamlayıcı Sağlık", "DASK", "Konut", "İşyeri",
  "Ferdi Kaza", "Hayat", "Seyahat", "Nakliyat", "Mühendislik", "Mesleki Sorumluluk",
  "İşveren Mali Sorumluluk", "Üçüncü Şahıs Mali Sorumluluk", "Zorunlu Mali Sorumluluk", "TARSİM",
  "Tekne / Yat", "Yol Yardım", "Evcil Hayvan", "Elektronik Cihaz", "Hukuksal Koruma", "Kredi",
  "Bireysel Emeklilik", "Yabancı Sağlık", "Yeşil Kart", "Kefalet", "Hırsızlık", "Cam Kırılması", "Siber Risk", "Hava Aracı", "Diğer",
];

export const PAYMENT_STATUSES = ["Ödendi", "Beklemede", "Kısmi"];

export const TYPE_BADGE = {
  Kasko: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Trafik: "bg-zinc-100 text-zinc-700 border-zinc-300",
  "İhtiyari Mali Mesuliyet": "bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200",
  Sağlık: "bg-emerald-50 text-emerald-700 border-emerald-200",
  "Özel Sağlık": "bg-teal-50 text-teal-700 border-teal-200",
  DASK: "bg-amber-50 text-amber-700 border-amber-200",
  Konut: "bg-sky-50 text-sky-700 border-sky-200",
  İşyeri: "bg-violet-50 text-violet-700 border-violet-200",
  "Ferdi Kaza": "bg-rose-50 text-rose-700 border-rose-200",
  Hayat: "bg-teal-50 text-teal-700 border-teal-200",
  Seyahat: "bg-cyan-50 text-cyan-700 border-cyan-200",
  Nakliyat: "bg-orange-50 text-orange-700 border-orange-200",
  Diğer: "bg-zinc-100 text-zinc-600 border-zinc-300",
};

export const PAYMENT_BADGE = {
  Ödendi: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Beklemede: "bg-amber-50 text-amber-700 border-amber-200",
  Kısmi: "bg-sky-50 text-sky-700 border-sky-200",
};

export function formatTRY(n) {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 0,
  }).format(Number(n || 0));
}

export function formatDate(d) {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return d;
  }
}
